import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  isExclusiveCollectionSpace?: boolean;
  name: string;
  quantity: number | null | undefined;
};
export const AccommodationRoomTitle = ({
  className,
  isExclusiveCollectionSpace = false,
  name,
  quantity = 1,
}: Props) => (
  <h3
    className={classnames(
      'flex items-baseline justify-between gap-20 font-brand text-20 font-bold leading-tight',
      {
        'text-black': !isExclusiveCollectionSpace,
        'text-ultramarine': isExclusiveCollectionSpace,
      },
      className,
    )}
  >
    <span>
      {name}{' '}
      {isExclusiveCollectionSpace && (
        <span className="inline-flex aspect-square h-[1em] items-center justify-center rounded-full bg-ultramarine leading-0 text-white">
          <Icon name={ICONS.DIAMOND} width="0.4em" />
        </span>
      )}
    </span>
    {!!quantity && quantity > 1 && (
      <TemplateString
        className="whitespace-nowrap font-brand text-18 text-black"
        template={t('booking.accommodation.packageContent.numberOfSameRooms')}
        valuesClassName={{
          count: 'text-24',
        }}
        values={{
          count: quantity,
        }}
      />
    )}
  </h3>
);
